import { ICON_LOCAL, LOCAL_STORAGE, ROUTE_NAME } from '@/common/constants';
import { getItem } from '@/common/storage';
import { useBook } from '@/hooks';

export default {
  setup() {
    const { book } = useBook();

    return { book };
  },
  data() {
    return {
      showExit: true
    };
  },
  created() {
    this.ICON_LOCAL = ICON_LOCAL;
    this.checkShowExit(this.$route.path);
  },
  watch: {
    ['$route.name'](path) {
      this.checkShowExit(path);
    }
  },
  methods: {
    /**
     * Check show Exit Yearbook Builder button with path name
     * @param  {String} pathName Current path name
     */
    checkShowExit(pathName) {
      if (
        pathName === ROUTE_NAME.PRINT_EDIT ||
        pathName === ROUTE_NAME.DIGITAL_EDIT
      ) {
        this.showExit = false;
      } else {
        this.showExit = true;
      }
    },

    onClickExit() {
      const origin_url = getItem(LOCAL_STORAGE.ORIGIN_URL) || false;
      if (!origin_url) {
        window.location.href = `${process.env.VUE_APP_ADMIN_URL}/communities/${this.book.communityId}/pp_book_project/${this.book.id}/edit`;
        return;
      }
      window.location.href = origin_url;
    }
  }
};
